import { render, staticRenderFns } from "./RouterProgressBar.vue?vue&type=template&id=3803d01a&scoped=true"
import script from "./RouterProgressBar.vue?vue&type=script&lang=js"
export * from "./RouterProgressBar.vue?vue&type=script&lang=js"
import style0 from "./RouterProgressBar.vue?vue&type=style&index=0&id=3803d01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803d01a",
  null
  
)

export default component.exports